import React from 'react'
import { MapPin, Camera, Mountain, Compass, Globe, Snowflake } from 'lucide-react'

const Travel = () => {
  const travelHighlights = [
    {
      title: "自驾中国",
      description: "用车轮丈量祖国大地，从繁华都市到偏远村落，感受中华文化的博大精深",
      icon: Compass,
      color: "from-red-500 to-pink-600",
      locations: ["川藏线", "新疆", "海南", "云南", "青海"]
    },
    {
      title: "环球旅行",
      description: "走遍世界各大洲，体验不同文明的独特魅力，用镜头记录世界的多彩",
      icon: Globe,
      color: "from-blue-500 to-cyan-600",
      locations: ["南极洲", "亚洲", "北美", "南美", "欧洲"]
    },
    {
      title: "南北极探险",
      description: "挑战地球两极的极端环境，在冰雪世界中感受大自然的震撼力量",
      icon: Snowflake,
      color: "from-cyan-500 to-blue-600",
      locations: ["南极洲", "北极圈", "国家地理", "极光极昼"]
    }
  ]

  const travelStats = [
    { label: "国家和地区", value: "30+", icon: MapPin },
    { label: "旅行天数", value: "800+", icon: Compass },
    { label: "拍摄照片", value: "10K+", icon: Camera },
    { label: "徒步爬山", value: "20+", icon: Mountain }
  ]

  return (
    <section id="travel" className="section-padding bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="container-custom">
        <div className="text-center mb-16">
          <h2 className="gradient-text mb-4">旅行足迹</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            从舒适圈到世界的边界，每一次旅行都是对未知的探索和对内心的追问
          </p>
        </div>

        {/* 旅行统计 */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16">
          {travelStats.map((stat, index) => (
            <div key={index} className="card text-center hover:scale-105 transform transition-all duration-300">
              <div className="w-12 h-12 bg-gradient-to-br from-primary-500 to-accent-500 rounded-full flex items-center justify-center mx-auto mb-3">
                <stat.icon size={24} className="text-white" />
              </div>
              <div className="text-2xl font-bold text-gray-800 mb-1">{stat.value}</div>
              <div className="text-sm text-gray-600">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* 旅行亮点 */}
        <div className="space-y-8">
          {travelHighlights.map((highlight, index) => (
            <div key={index} className="card hover:shadow-2xl transition-all duration-500">
              <div className="flex flex-col lg:flex-row items-start gap-8">
                <div className="flex-shrink-0">
                  <div className={`w-20 h-20 rounded-2xl bg-gradient-to-br ${highlight.color} flex items-center justify-center mb-4`}>
                    <highlight.icon size={40} className="text-white" />
                  </div>
                </div>
                
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-gray-800 mb-4">{highlight.title}</h3>
                  <p className="text-gray-600 mb-6 leading-relaxed">{highlight.description}</p>
                  
                  <div className="flex flex-wrap gap-2">
                    {highlight.locations.map((location, locationIndex) => (
                      <span
                        key={locationIndex}
                        className="px-4 py-2 bg-gradient-to-r from-primary-50 to-accent-50 text-primary-700 rounded-full text-sm font-medium border border-primary-100 hover:scale-105 transform transition-all duration-300"
                      >
                        {location}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* 照片/视频预留区域 */}
        <div className="mt-16">
          <div className="card bg-gradient-to-r from-primary-50 to-accent-50 border-2 border-primary-100 text-center">
            <div className="flex flex-col items-center gap-4">
              <div className="w-16 h-16 bg-gradient-to-br from-primary-500 to-accent-500 rounded-full flex items-center justify-center">
                <Camera size={32} className="text-white" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">精彩瞬间即将呈现</h3>
                <p className="text-gray-600">
                  正在整理旅行照片和视频，即将为您展示世界各地的美丽风景和难忘时刻
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* 旅行感悟 */}
        <div className="mt-16 text-center">
          <blockquote className="text-xl italic text-gray-700 max-w-4xl mx-auto">
            "旅行不仅是地理位置的移动，更是心灵的成长和视野的拓展。<br/>
            每一次出发都是为了更好地回归，每一次探索都是为了更深地理解。"
          </blockquote>
          {/* <div className="mt-4 text-gray-500">— Jordan 乔丹</div> */}
        </div>
      </div>
    </section>
  )
}

export default Travel 